"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santa-caterina-d-este": {
    "8baf2414": [{
      "hkey": "b45f09ea",
      "slug": "carceri",
      "name": "Carceri",
      "primary": true,
      "skipSearch": false
    }],
    "e68b4ff2": [{
      "hkey": "cab04705",
      "slug": "vighizzolo-d-este",
      "name": "Vighizzolo d'Este",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;